import React, { useState } from 'react';
import api from '../services/api';
import { passkeyBeschikbaar, passkeyRegistreren } from '../services/passkey';

// Instellingen → 2FA-tab: passkey toevoegen (wachtwoordloos inloggen)
export default function PasskeyBeheer() {
  const [bezig, setBezig] = useState(false);
  const [msg, setMsg] = useState('');
  if (!passkeyBeschikbaar()) return null;
  const toevoegen = async () => {
    setBezig(true); setMsg('');
    try { const r = await passkeyRegistreren(api); setMsg(r?.success === false ? (r.message || 'Mislukt') : 'Passkey toegevoegd. Je kunt nu inloggen zonder wachtwoord.'); }
    catch (e) { setMsg(e?.name === 'NotAllowedError' ? 'Geannuleerd.' : e?.name === 'InvalidStateError' ? 'Dit apparaat heeft al een passkey voor WOMsys.' : (e?.response?.data?.message || e.message || 'Mislukt')); }
    finally { setBezig(false); }
  };
  return (
    <div style={{ marginBottom: 20, padding: 16, borderRadius: 10, border: '1px solid #e5e7eb', background: '#f9fafb' }}>
      <h3 style={{ margin: '0 0 6px' }}>🔑 Passkey</h3>
      <p style={{ margin: '0 0 12px', color: '#4b5563', fontSize: 14 }}>Inloggen met vingerafdruk, gezicht, Windows Hello of een beveiligingssleutel — zonder wachtwoord.</p>
      <button type="button" className="btn-primary" onClick={toevoegen} disabled={bezig}>{bezig ? 'Bezig…' : 'Passkey toevoegen'}</button>
      {msg && <div style={{ marginTop: 10, fontSize: 14 }}>{msg}</div>}
    </div>
  );
}
